export const setIntercomSettings = (data) => {
    window.intercomSettings = data
}
export const isIntercomEnabledAndSetup = () => {
    return Boolean(window.Intercom)
}
export const bootIntercom = (data) => {
    try {
        if (!isIntercomEnabledAndSetup()) return
        window.Intercom("boot", data);
        console.info("Intercom boot")
    } catch (e) {
        console.warn(e)
    }
}
export const updateIntercom = (data) => {
    try {
        if (!isIntercomEnabledAndSetup()) return
        window.Intercom("update", data);
    } catch (e) {
        console.warn(e)
    }
}
export const trackIntercomEvent = (event) => {
    try {
        if (!isIntercomEnabledAndSetup()) return
        window.Intercom("trackEvent", event);
    } catch (e) {
        console.warn(e)
    }
}
export const shutdownIntercom = (data) => {
    try {
        if (!isIntercomEnabledAndSetup()) return
        window.Intercom("shutdown");
        console.info("Intercom shutdown")
    } catch (e) {
        console.warn(e)
    }
}

export default {
    setIntercomSettings,
    isIntercomEnabledAndSetup,
    bootIntercom,
    updateIntercom,
    trackIntercomEvent,
    shutdownIntercom,
}